import React from 'react';
import { createPortal } from 'react-dom';

import useDefaultModal from './default-modal.controller';

const ID = 'default-modal';
export interface DefaultModalProps {
    id?: string;
    handleClose: () => void;
    show: boolean;
    children?: React.ReactNode;
    type?: ModalType;
    customWidth?: number;
    className?: string;
}

export const DefaultModal = (props: DefaultModalProps) => {
    const viewProps = useDefaultModal(props);

    if (!props.show) {
        return <></>;
    }

    const root = document.getElementById('root');
    if (!root) throw new Error('Root node not found. Cannot render modal.');

    const modalVariants = {
        [ModalType.PROMPT]: 'modal-prompt',
        [ModalType.PANE]: 'modal-pane',
        [ModalType.MOBILE_BOTTOM]: 'modal-mobile-bottom',
        [ModalType.BOTTOM]: 'modal-bottom'
    };

    return createPortal(
        <div
            id='default-modal'
            tabIndex={-1}
            aria-hidden='true'
            className={`${props.show ? 'show backdrop-brightness-50' : 'hidden'} flex overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-1000 justify-center items-center w-full md:inset-0 h-full max-h-full`}>
            <div
                className={`${props.className ? props.className : ''} ${modalVariants[props.type || ModalType.PROMPT]} ${props.customWidth ? `w-[${props.customWidth}%] : ''}` : 'w-full'}`}
                ref={viewProps.modalRef}>
                {props.children}
            </div>
        </div>,
        root
    );
};

export enum ModalType {
    PROMPT = 'prompt',
    PANE = 'pane',
    MOBILE_BOTTOM = 'mobile-bottom',
    BOTTOM = 'bottom'
}
